import {optimizelyUserId as optimizelyUserIdMiddleware} from '@s-ui/segment-wrapper/lib/middlewares/source/optimizelyUserId'

import {DESTINATION_NAMES} from '../../../config.js'
import {optimizelyTrackingMiddleware} from './optimizely/optimizelyTrackingMiddleware.js'
import setGoogleTagManagerProperties from './setGoogleTagManagerProperties/index.js'

const {GOOGLE_TAG_MANAGER, OPTIMIZELY} = DESTINATION_NAMES

// Set destination middlewares for Coches.net.
export default [
  {
    [GOOGLE_TAG_MANAGER]: [setGoogleTagManagerProperties]
  },
  {
    [OPTIMIZELY]: [optimizelyUserIdMiddleware, optimizelyTrackingMiddleware]
  }
]
